import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import { makeStyles } from '@material-ui/core/styles'
import compStyles from './home.module.scss'
import Image2 from '../../assets/images/home/home2.gif'

import Banner from './Banner'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'space-evenly',
    flexDirection: 'column'
  },
  banner: {
    minWidth: '65%',
    width: 'calc(100% - 20px)',
    margin: '10px'
  },
  image: {
    minWidth: '320px',
    width: 'calc(100% - 20px)',
    margin: '10px'
  },
  gridImages: {
    minWidth: '30%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly'
  },
  '@media screen and (min-width: 899px)': {
    banner: {
      width: 'calc(60% - 40px)',
      margin: '40px'
    },
    container: {
      flexDirection: 'row'
    },
    image: {
      width: '320px',
      margin: '20px'
    }
  },
  '@media screen and (min-width: 1099px)': {
    banner: {
      width: 'calc(60% - 40px)',
      margin: '20px'
    },
    image: {
      width: 'calc(100% - 30px)',
      margin: '20px'
    }
  }
})

const NotFoundPage = () => {
  const classes = useStyles()
  const home = useStaticQuery(graphql`
    query {
      home1: file(relativePath: { eq: "home/home1.png" }) {
        childImageSharp {
          fluid(quality: 100, maxHeight: 480, maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }     
    }
  `)

  return (
    <section className={classes.container}>
      <div className={classes.banner}>
        <Banner className={compStyles.banner} />
      </div>
      <div className={classes.gridImages}>
        <a href="/enquiry"><Img fluid={home.home1.childImageSharp.fluid} className={classes.image} /></a>
        <img src={Image2} className={classes.image} alt="sathyam shivam seva" />
      </div>
    </section>
  )
}

export default NotFoundPage
